import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../../basic/index';
import { Spinner } from '../../../../../common/index';
import {
  useDeleteErasmusQuestionnaireMutation,
  useGetErasmusQuestionnaireQuery,
  useGetErasmusQuestionnairesQuery,
  useSaveErasmusQuestionnaireMutation,
} from '../../../../../../redux/services/erasmusQuestionnaire';
import { routes } from '../../../../../../utils/helpers/ApiClient';
import ErasmusQuestionnaireForm from './ErasmusQuestionnaireForm/ErasmusQuestionnaireForm';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';

const ErasmusQuestionnaire = ({ mode, id: propId }) => {
  const { id, mobility_id } = useParams();
  // Uprednostni propId, potom id z URL, potom mobility_id
  const displayId = propId || (mode === 'create' ? mobility_id : id);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';
  const isPreview = mode === 'preview';

  const { data: questionnaireDetail, isLoading } =
    useGetErasmusQuestionnaireQuery(displayId, {
      skip: !isEdit && !isPreview,
    });

  const { saveSuccess, deleteSuccess, apiErrorMessage } = useToastMessages();

  const [
    deleteErasmusQuestionnaire,
    { isSuccess: isDeleteSuccess, error: deleteError },
  ] = useDeleteErasmusQuestionnaireMutation();

  const [
    saveErasmusQuestionnaire,
    { isSuccess: isSaveSuccess, error: saveError },
  ] = useSaveErasmusQuestionnaireMutation();

  const { refetch } = useGetErasmusQuestionnairesQuery();

  useEffect(() => {
    if (isSaveSuccess) {
      saveSuccess();
      navigate(routes.cmsErasmusMobility);
      refetch();
    } else if (saveError) {
      apiErrorMessage(saveError);
    }
  }, [isSaveSuccess, saveError]);

  useEffect(() => {
    if (isDeleteSuccess) {
      deleteSuccess();
      navigate(routes.cmsErasmusMobility);
      refetch();
    } else if (deleteError) {
      apiErrorMessage(deleteError);
    }
  }, [isDeleteSuccess, deleteError]);

  const title = (isCreate && t('Dotazník')) || t('Editovanie dotazníka');

  if (isLoading || (isEdit && !questionnaireDetail)) {
    return <Spinner />;
  }

  const initials =
    isEdit || isPreview
      ? {
          ...questionnaireDetail.questionnaire,
        }
      : {
          mobility_id: undefined,
          study_field: undefined,
          study_program: undefined,
          duration: undefined,
          web_info: undefined,
          reason_for_choosing: undefined,
          subjects_rating: undefined,
          environment_interaction: undefined,
          domestic_students: undefined,
          foreign_students: undefined,
          subjects_explanation: undefined,
          subjects_recommendation: undefined,
          interaction_teachers: undefined,
          subjects_offer: undefined,
          means_of_transport: undefined,
          travel_recommendation: undefined,
          arrival_abroad: undefined,
          transport_rating: undefined,
          housing_rating: undefined,
          city_rating: undefined,
          free_time_rating: undefined,
          acquaintance_domestic_students: undefined,
          acquaintance_foreign_students: undefined,
          buddy: undefined,
          orientation_welcome_days_week: undefined,
          costs_administration: undefined,
          costs_application: undefined,
          costs_travel: undefined,
          costs_travel_insurance: undefined,
          costs_housing: undefined,
          food_rating: undefined,
          costs_food: undefined,
          other_costs: undefined,
          biggest_costs: undefined,
          total_costs: undefined,
          finance_rating: undefined,
          search_for_accommodation: undefined,
          about_housing: undefined,
          payment_problems: undefined,
          electronic_devices_problems: undefined,
          cost_of_living: undefined,
          other_administrative_responsibilities: undefined,
          comunication_with_locals: undefined,
          satisfaction_with_country: undefined,
          unexpected_life_situation: undefined,
          esn_activity: undefined,
          crisis_situation: undefined,
          end_of_mobility: undefined,
          summarization: undefined,
          overall_rating: undefined,
        };

  if (!initials) return <Spinner />;

  return (
    <>
      {!isPreview && (
        <AppBarCMS
          title={title}
          backUrl={routes.cmsErasmusMobility}
          backUrlTooltip={t('Mobility')}
          onDelete={
            !isCreate ? () => deleteErasmusQuestionnaire(displayId) : undefined
          }
          permissionsBasic={'erasmus-applications'}
        />
      )}
      <div style={{ margin: '10px' }}>
        <ErasmusQuestionnaireForm
          initials={initials}
          isPreview={isPreview}
          onSubmit={(values) => {
            const body = {
              ...values,
              mobility_id: displayId,
            };
            saveErasmusQuestionnaire({
              body: body,
              ...(!isCreate && { id: displayId }),
            });
          }}
        />
      </div>
    </>
  );
};

export default ErasmusQuestionnaire;
